import { WhatsAppIcon } from "./WhatsAppIcon";

const WHATSAPP =
  "https://wa.me/5545999175813?text=" +
  encodeURIComponent(
    "Olá! Vim pelo site do Dr. Kelson Kawamura e gostaria de mais informações."
  );

export function FloatingWhatsApp() {
  return (
    <a
      href={WHATSAPP}
      target="_blank"
      rel="noopener noreferrer"
      className="kk-fab-whatsapp"
      aria-label="Falar pelo WhatsApp"
    >
      <WhatsAppIcon size={30} />
    </a>
  );
}
